export const assets = {
  "title": "Assets",
  "categories": {
    "left": [
      {
        "title": "Cash",
        "index": 0,
        "fields": [
          { "title": "Checking Accounts" },
          { "title": "Savings Accounts" },
          { "title": "CDs" },
          { "title": "Savings Bonds" },
          { "title": "Other/Under the Mattress" }
        ]
      },
      {
        "title": "Retirement savings",
        "index": 1,
        "fields": [
          { "title": "IRAs" },
          { "title": "401(k)s" },
          { "title": "Keogh Accounts" },
          { "title": "Pensions", "description": "Only the amount you could withdraw in cash today" },
          { "title": "Other" }
        ]
      },
      {
        "title": "Other investments / Brokerage accounts",
        "index": 2,
        "fields": [
          { "title": "Stocks" },
          { "title": "Bonds" },
          { "title": "Mutual Funds" },
          { "title": "Other" },
          { "title": "Value of businesses you own", "bold": true }
        ]
      }
    ],
    "right": [
      {
        "title": "Life insurance / Annuities",
        "index": 3,
        "fields": [
          { "title": "Cash Value of Life Insurance" },
          { "title": "Surrender Value of Annuities" }
        ]
      },
      {
        "title": "Current market value of home(s)",
        "index": 4,
        "fields": [
          { "title": "Primary Residence" },
          { "title": "Rental/Vacation Properties" }
        ]
      },
      {
        "title": "Property",
        "index": 5,
        "fields": [
          { "title": "Cars" },
          { "title": "Motorcycles/RVs/Other" },
          { "title": "Boats" },
          { "title": "Household Furnishings" },
          { "title": "Appliances" },
          { "title": "Jewelry" },
          { "title": "Antiques" },
          { "title": "Collections" },
          { "title": "Other" }
        ]
      }]
  }
};

export const liabilities = {
  "title": "Liabilities",
  "categories": {
    "left": [
      {
        "title": "Balance due on debts",
        "index": 0,
        "fields": [
          { "title": "Credit Cards" },
          { "title": "Mortgages" },
          { "title": "Home-Equity Loans" },
          { "title": "Auto Loans" },
          { "title": "Student Loans" },
          { "title": "Other Loans/Debts" }
        ]
      }
    ],
    "right": [
      {
        "title": "Bills due",
        "index": 1,
        "fields": [
          { "title": "Household Utilities" },
          { "title": "Taxes Due" }
        ]
      }
    ]
  }
};

export const result = {
    "title": "Your Net Worth",
    "assets": "Total Assets: ",
    "liabilities": "Total Liabilities: "
};

export const actions = {
    "clear": "Clear Form / Start Over"
};
